import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core/';
import {
    Input, Snackbar, TextField
} from "@material-ui/core";
import api from '../../services/api';
import AlertHelper from '../../components/Alert';
import CheckIcon from '@material-ui/icons/Check';

export async function getHistory(structureId) {

    let response = await api.get(`/idcardhistory/odata?$filter=structureId +eq+${structureId}&$select=*`);

    if (response.status === 200)
        return response.data.value;
    else
        return [];

}

const HistoryYearModalForm = ({ item, showModal = false, callback}) => {
    
    const [openModal, setShowModal] = useState(showModal)
    const [historyArray, setHistoryArray] = useState([])

    const [snackBar, setSnackBar] = useState({
        isOpen: false,
        message: '',
        vertical: 'top',
        horizontal: 'right',
        type: 'error'
    });

    useEffect(() => {

        const init = async () => {
            setShowModal(showModal);
            const historyApi = await getHistory(item.structureId);

            var tempHistory = [];
            for (var i = 2023; i > 2000; i--) {
                tempHistory.push({ year: i, total: 0, eliminated: 0, structureId: item.structureId });
            }

            historyApi.forEach(item => {

                const idx = tempHistory.findIndex(i => i.year == item.year);
                if (idx > -1) {
                    tempHistory[idx] = item;
                }
            });

            setHistoryArray(tempHistory);        
        }
       
        if (item.structureId)
            init();
    }, [item]);

    const handleClose = () => {
        setShowModal(false)
        callback();
    }

    const handleSave = async (i) => {       
        var element = historyArray[i]

        if (element.total < element.eliminated) {
            setSnackBar({
                ...snackBar,
                isOpen: true,
                message: "Erro, valores de eliminados não podem ser maior que o total!",
                type: 'error'
            })
            return;
        }

        let response;
        if (element.id > 0) {
            const body =
            {
                createdAt: element.createdAt,
                year: element.year,
                total: element.total,
                eliminated: element.eliminated,
                structureId: element.structureId,
                id: element.id
            }

            response = await api.put(`/idcardhistory`, body);
        }
        else {
            const body =
            {
                year: element.year,
                total: element.total,
                eliminated: element.eliminated,
                structureId: element.structureId
            }

            response = await api.post(`/idcardhistory`, body);
            console.log(response)
            if (response.status === 200) {
                var tempArray = [...historyArray];
                tempArray[i].id = response.data.id;
                setHistoryArray(tempArray);
            }
        }

        if (response.status === 200) {            
            setSnackBar({ ...snackBar, isOpen: true, message: 'Salvo com sucesso.', type: 'success' })
        }
        else {
            setSnackBar({
                ...snackBar,
                isOpen: true,
                message: "Erro ao salvar, tente novamente!",
                type: 'error'
            })
        }

    }

    const changeTotal = (value, i) => {
        var tempArray = [...historyArray];
        tempArray[i].total = parseInt(value);
        setHistoryArray(tempArray);
    }

    const changeElimin = (value, i) => {
        var tempArray = [...historyArray];
        tempArray[i].eliminated = parseInt(value);
        setHistoryArray(tempArray);
    }

    /**
* Update state snackbar for close
*/
    const handleCloseSnackbar = async () => {
        setTimeout(function () {
            setSnackBar({ ...snackBar, isOpen: false, message: '' })
        }, 3000);
    }

    return (
        <>
         <Snackbar
                        open={snackBar.isOpen}
                        anchorOrigin={{ vertical: snackBar.vertical, horizontal: snackBar.horizontal }}
                        key={snackBar.vertical + snackBar.horizontal}
                        autoHideDuration={3000}
                        onClose={handleCloseSnackbar}
                    >
                        <AlertHelper onClose={handleCloseSnackbar} severity={ snackBar.type}>
                            {snackBar.message}
                        </AlertHelper>
                    </Snackbar>
        <Modal size='lg' centered show={openModal} onHide={handleClose}>
        <Modal.Header closeButton>
                <Modal.Title>Configurar histórico de idcards elminados por ano do { item.label }</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <TableContainer>
						<Table stickyHeader aria-label="sticky table">
							<TableHead>
                                <TableRow>
                                    <TableCell>Ano</TableCell>
                                    <TableCell>Total</TableCell>
									<TableCell>Eliminados</TableCell>
									<TableCell>Salvar</TableCell>
                                </TableRow>
                            </TableHead>
							<TableBody>
                            {historyArray.map((row, i) => (
								<TableRow key={i}>
									<TableCell>
                                        { row.year }
									</TableCell>
									<TableCell>                                        
                                        <TextField  type='number' InputProps={{ inputProps: { min: 0 } }} value={row.total} onChange={(e) => changeTotal(e.target.value, i)} placeholder={0}/>
									</TableCell>
									<TableCell>
                                        <TextField type='number' InputProps={{ inputProps: { min: 0 } }}  value={row.eliminated} onChange={(e) => changeElimin(e.target.value, i)} placeholder={0} />
                                    </TableCell>
                                    <TableCell>
                                        <Button variant="primary" size="sm" style={{ marginRight: '10px' }} onClick={e => handleSave(i)}>
                                            <CheckIcon />
                                        </Button>
                                    </TableCell>
								</TableRow>
							))}
							</TableBody>
						</Table>
                    </TableContainer>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={handleClose}>Fechar</Button>
            </Modal.Footer>
        </Modal>
        </>
    )
}

export default HistoryYearModalForm